module.exports = __webpack_public_path__ + "img/dateEle.e3cb87df.svg";